import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-piechart',
  templateUrl: './piechart.component.html',
  styleUrls: ['./piechart.component.css']
})
export class PiechartComponent implements OnInit {

  @Input() datos: any[] = [];


  // Doughnut
  public doughnutChartLabels: string[];
  public doughnutChartData: number[];
  public doughnutChartType = 'doughnut';
  public colors: Array<any> = [ {
    backgroundColor: ['#661b2e', '#bb4d00', '#6c6f00', '#6be566', '#613b2c', '#3b8d36']
  }];

  constructor() {
  }

  ngOnInit () {
    console.log("DATOSSSSSSSS", this.datos)
    this.doughnutChartLabels = ['Matriculaciones', 'Cambios de propiedad', 'Distintivos medioambientales', 'Justificantes', 'Informes', 'Reduccion IVA 4%'];
    this.doughnutChartData = [this.datos[0], this.datos[1], this.datos[2], this.datos[3] , this.datos[4], this.datos[5]];

  }

  // events
  public chartClicked (e: any): void {
    console.log(e);
  }

  public chartHovered (e: any): void {
    //console.log(e);
  }

}
